export default __webpack_public_path__ + "static/opengraph-8ffc2772aa0245bafbe37e81ae97ffe5.png";